angular.module('app.prospection.search', []);
/**
 * Module search prospection
 * @module app.prospection.search
 */
require('modules/prospection/search/controllers/searchCtrl');
require('modules/prospection/search/directives/mapDirective');
require('modules/prospection/search/services/departementsService');

function prospectionSearchRouter($routeProvider) {
    $routeProvider.when('/prospection/search/', {
        templateUrl: 'prospection/search/partials/search.html',
        controller: 'SearchCtrl',
        controllerAs: 'searchCtrl',
        params: {
            menuTitle: 'Rechercher'
        }
    });
}
prospectionSearchRouter.$inject = ['$routeProvider'];

angular.module('app.prospection.search').config(prospectionSearchRouter);
